import { render, staticRenderFns } from "./OffersDetailsList.vue?vue&type=template&id=6f0bf4ca"
import script from "./OffersDetailsList.vue?vue&type=script&lang=ts"
export * from "./OffersDetailsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports